import { Component, Input, OnInit } from '@angular/core';
import { MailService } from 'src/app/lib/mail/services/mail.service';

@Component({
  selector: 'app-msg-preview',
  templateUrl: './msg-preview.component.html',
  styleUrls: ['./msg-preview.component.css']
})
export class MsgPreviewComponent implements OnInit {

  @Input() blob: Blob;
  @Input() fileName: string;

  status = MsgPreviewComponentStatus.INITIAL;
  htmlBody = null;
  
  constructor(
    private _mailService: MailService
  ) { }

  ngOnInit(): void {
    this.renderBlob();
  }

  renderBlob(){
    this._mailService.renderMsgAsHtml(this.blob, this.fileName).subscribe((result) => {
      this.htmlBody = result;
    });
  }

}

export const MsgPreviewComponentStatus = {
  INITIAL: 0,
  RENDERING: 1,
  SUCCEEDED: 2,
  FAILED: 3
}
